import React, { forwardRef, useRef, useState, useEffect } from "react";
import UserInputBarWithSendOnly from "./UserInputBarWithSendOnly";
import SocketMicStreamer from "./SocketMicStreamerNewUi";
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';


import {
  setInputValue,
} from "../../../store/features/ui/uiSlice";

import { selectIsHideUserInputFields,selectSelectedChatId } from "../../../store/features/message/textContentSelectors";
import { updateFlowStates } from "../../../store/features/message/updateFlowStates";

const SepratedInputChnages = forwardRef(({ handleSend, onKeyDown, isUserInputBar, isTypingRef },ref) => {
  const dispatch = useDispatch();
  const selectedChatId = useSelector(selectSelectedChatId);
  const isHideUserInputBar = useSelector(selectIsHideUserInputFields);

  const micStreamerRef = useRef(null);


  const [isTextareaVisible] = useState(false);
  const [onDynamicFormSubmit] = useState(false);
  const [getFormAnswers] = useState(null);



  const handleSearchChange = (e) => {
    dispatch(setInputValue(e.target.value));
    dispatch(updateFlowStates());
  };


  useEffect(() => {
    if (onDynamicFormSubmit && getFormAnswers && Object.keys(getFormAnswers).length > 0) {
      dispatch(setInputValue(Object.values(getFormAnswers).join(",")));
      dispatch(updateFlowStates());
    }
  }, [onDynamicFormSubmit, getFormAnswers, dispatch]);

  return (
    <>
      {
        isHideUserInputBar ? (null) : (<div className="flex items-center">
          {!isTextareaVisible && (
            <UserInputBarWithSendOnly
              isTypingRef={isTypingRef}
              onChange={handleSearchChange}
              onKeyDown={onKeyDown}
              handleSend={handleSend}
            />
          )}

          {
            selectedChatId && (
              <SocketMicStreamer
                key="mic-streamer-input"
                ref={micStreamerRef}
                isUserInputBar={isUserInputBar}
              />
            )
          }

        </div>)
      }
    </>
  );
});

SepratedInputChnages.propTypes = {
  handleSend: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  isUserInputBar: PropTypes.bool,
  isTypingRef: PropTypes.object,
};

SepratedInputChnages.displayName = "SepratedInputChnages";
export default SepratedInputChnages;
